import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { money } from "../../lib/api";

const LABEL = { pc: "PC", ps: "PlayStation", xbox: "Xbox" };
const tip = { contentStyle: { background: "#0b0b11", border: "1px solid rgba(255,255,255,0.15)", fontFamily: "JetBrains Mono", fontSize: 12 }, labelStyle: { color: "#94a3b8" } };
const axis = { stroke: "#94a3b8", fontSize: 11, fontFamily: "JetBrains Mono", tickLine: false, axisLine: false };

const Panel = ({ title, children, className = "", testId }) => (
  <div className={`border border-white/10 bg-[#0f0f16] p-5 ${className}`} data-testid={testId}>
    <p className="font-mono text-[11px] uppercase tracking-widest text-slate-400">{title}</p>
    <div className="mt-4 h-64">{children}</div>
  </div>
);

export const SalesCharts = ({ stats }) => {
  const days = (Array.isArray(stats?.by_day) ? stats.by_day : []).map((d) => ({ ...d, label: d.date.slice(5) }));
  const plats = (Array.isArray(stats?.by_platform) ? stats.by_platform : []).map((p) => ({ ...p, label: LABEL[p.platform] ?? p.platform }));

  return (
    <div className="mt-6 grid gap-3 lg:grid-cols-3" data-testid="sales-charts">
      <Panel title="Revenue & orders · last 30 days" className="lg:col-span-2" testId="chart-by-day">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={days} margin={{ left: -10, right: 8 }}>
            <defs>
              <linearGradient id="rev" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#a259ff" stopOpacity={0.4} />
                <stop offset="100%" stopColor="#a259ff" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey="label" {...axis} interval="preserveStartEnd" minTickGap={28} />
            <YAxis yAxisId="r" {...axis} tickFormatter={(v) => `$${v}`} />
            <YAxis yAxisId="o" orientation="right" {...axis} allowDecimals={false} />
            <Tooltip {...tip} formatter={(v, n) => (n === "revenue" ? [money(v), "Revenue"] : [v, "Orders"])} />
            <Area yAxisId="r" type="monotone" dataKey="revenue" stroke="#a259ff" strokeWidth={2} fill="url(#rev)" />
            <Area yAxisId="o" type="monotone" dataKey="orders" stroke="#ff3dc8" strokeWidth={2} fill="transparent" />
          </AreaChart>
        </ResponsiveContainer>
      </Panel>
      <Panel title="By platform" testId="chart-by-platform">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={plats} margin={{ left: -10, right: 8 }}>
            <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey="label" {...axis} />
            <YAxis {...axis} tickFormatter={(v) => `$${v}`} />
            <Tooltip {...tip} cursor={{ fill: "rgba(255,255,255,0.04)" }} formatter={(v, n, item) => [`${money(v)} · ${item?.payload?.orders ?? 0} orders`, "Revenue"]} />
            <Bar dataKey="revenue" fill="#c084fc" radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </Panel>
      <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500 lg:col-span-3">
        <span className="text-[#c084fc]">Purple</span> = paid revenue · <span className="text-[#ff3dc8]">pink</span> = orders placed (not cancelled) · days in UTC
      </p>
    </div>
  );
};
